<template>
  <div class="container-body">
    <div class="d-flex align-items-center justify-content-center">
      <form v-if="!showChangePassword" v-on:submit="submit">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">Email</label>
          <div class="col-sm-8">
            <input v-model="email" type="email" class="form-control" required />
          </div>
        </div>
        <button type="submit" class="custom-mobile-button-login">
          {{ $t("ResetPassword.Recover") }}
        </button>
        <div style="margin-top: 10px">
          <div v-if="showResetPassordError" class="alert alert-danger">
            {{ $t("ResetPassword.Error") }}
          </div>
          <div v-if="showResetPassordSuccess" class="success alert-success">
            {{ $t("ResetPassword.Success") }}
          </div>
        </div>
        <router-link to="/">
          {{ $t("Login.Login") }}
        </router-link>
      </form>
    </div>
    <div class="footer-body">
      <Version />
    </div>
  </div>
</template>

<script>
import AccountService from "../services/AccountService";
import LocalStorageService from "../services/LocalStorageService";
import Version from "../components/Version";

export default {
  name: "ResetPassword",
  accountService: null,
  localStorageService: null,
  data() {
    return {
      showChangePassword: false,
      loader: {},
      showResetPassordError: false,
      showResetPassordSuccess: false,
      showTokenError: false,
      email: "",
      password: "",
      cfpassword: "",
      token: ""
    };
  },
  components: { Version },
  created() {
    this.accountService = new AccountService();
    this.localStorageService = new LocalStorageService();
    const token = this.localStorageService.getAuthToken();
    const loggedInEmployee = this.localStorageService.getCurrentEmployee();
    if (token && loggedInEmployee) {
      return this.$router.push({ name: "work-days" });
    }
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.showResetPassordError = false;
      this.showResetPassordSuccess = false;
      this.loader = this.$loading.show({});
      this.accountService
        .resetPassword(this.email)
        .then(() => {
          this.loader.hide();
          this.showResetPassordSuccess = true;
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            this.showResetPassordError = true;
          }
          this.loader.hide();
        });
    },

  },
};
</script>

<style>
.custom-mobile-button-login {
  background: #007ad9;
  color:white;
  border: 0px;
  width: 100%;
  padding: 10px;
  font-size: 20px;
  border-radius: 5px;
  z-index: 99;
  margin-top: 20px;
}
</style>
